import { ASPECTS } from "@ecliptica/game-ui";
import { useTranslation, type Lang } from "@ecliptica/i18n";
import { aspects } from "@ecliptica/tokens";
import { Button } from "@ecliptica/ui";
import { Link } from "react-router";
import { worldPath } from "../../lib/lang";
import { FACTION_ART, art } from "../../content/site";
import { Panel, Section } from "./Section";

const SYMBOL = { sol: "☀", lua: "☾", eclipse: "◐" } as const;
const WORLD_ID = { sol: "sun", lua: "moon", eclipse: "eclipse" } as const;

export function WorldSection({ lang }: { lang: Lang }) {
  const { t } = useTranslation();
  return (
    <Section id="world" title={t("world.title")} lead={<span className="block max-w-[920px]">{t("world.lead")}</span>}>
      <div className="mx-auto grid max-w-[1200px] gap-4.5 md:grid-cols-3">
        {ASPECTS.map((a) => (
          // Cada astro leva à sua página no Mundo.
          <Link key={a} to={worldPath(lang, [WORLD_ID[a]])} className="group block focus-visible:outline-2 focus-visible:outline-ring">
            <Panel className="h-full overflow-hidden transition-colors group-hover:border-gold">
              <img src={art(FACTION_ART[a])} alt="" loading="lazy" decoding="async" width={768} height={432} className="aspect-video w-full object-cover" />
              <h3 className="px-5 pt-4 text-xl font-extrabold" style={{ color: aspects[a] }}>
                {SYMBOL[a]} {t(`world.astro.${a}.t`)}
              </h3>
              <p className="px-5 pb-5 pt-1 text-moon">{t(`world.astro.${a}.d`)}</p>
            </Panel>
          </Link>
        ))}
      </div>
      <div className="mt-8 text-center">
        <Button asChild variant="primary" size="lg">
          <Link to={worldPath(lang)}>{t("world.explore")}</Link>
        </Button>
      </div>
    </Section>
  );
}
